/* eslint-disable no-param-reassign */
import React, { useState } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import { Mutation } from '@apollo/client/react/components';
import { IconButton } from '@material-ui/core';
import { ConfirmDialog } from '../../../components/ConfirmDialog/index';
import { REMOVE_WRITER, GET_WRITERS } from '../../../queries/writer';
import Loading from '../../../components/Loading';

function filteredData(s, l, ls) {
  s.data.forEach(d => {
    const { id } = ls[d.dataIndex];
    l = l.filter(e => e.id !== id);
  });
  return l;
}

export default function Delete({ selectedRows, writers }) {
  const [openDialog, setOpenDialog] = useState(false);
  const [openLoading, setOpenLoading] = useState(false);

  const removeUsersSelected = (removeUser) => {
    setOpenDialog(false);
    setOpenLoading(true);
    selectedRows.data.forEach(d => {
      const { id } = writers[d.dataIndex];
      removeUser({ variables: { id } });
    });
    setOpenLoading(false);
  };
  return (
    <Mutation
      mutation={REMOVE_WRITER}
      update={(store) => {
        const { userListWriters } = store.readQuery({ query: GET_WRITERS });
        store.writeQuery({
          query: GET_WRITERS,
          data: { userListWriters: filteredData(selectedRows, userListWriters, writers) },
        });
      }}
    >
      {removeUser => (
        <div>
          <Loading openLoading={openLoading} />
          <ConfirmDialog
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            title="Are you sure? "
            contentText="Are you sure that you want to remove ?"
            handleConfirmation={() => removeUsersSelected(removeUser)}
          />
          <IconButton aria-label="delete" onClick={() => setOpenDialog(true)}>
            <DeleteIcon />
          </IconButton>
        </div>
      )}
    </Mutation>
  );
}
